import React from 'react';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const PlusIcon = ({ toolTipText = 'Add' }) => (
  <Icon tooltip={ toolTipText } iconObj={faPlus} />
);

export default PlusIcon;